import { useEffect, useState } from "react";

import TabButton from "@/components/actions/button/tabBtn";
import ItemDetailsAccordion from "@/components/data-display/accordion/itemDetails";

import ItemVideoSection from "../itemVideo";
import ProductQuestionSection from "../productQuestion";
import ProductReviewSection from "../productReview";
import { InformativeItem } from "./InformativeItem";

function ProductDetailsTab({ data = {}, productName }) {
  const { reviews, long_description, specification, questions, videos } = data;
  const [selectedTab, setSelectedTab] = useState("description");

  useEffect(() => {
    setSelectedTab("description");
  }, [data]);

  const reviewsCount = reviews?.total_review_count
    ? `(${reviews?.total_review_count})`
    : "";
  const questionsCount = questions?.total_question_count
    ? `(${questions?.total_question_count})`
    : "";

  const tabBody = {
    description: <InformativeItem type="description" data={long_description} />,
    specification: (
      <InformativeItem type="specification" data={specification} />
    ),
    video: <ItemVideoSection videoUrl={videos?.[0]?.video_url} />,
    review: <ProductReviewSection data={reviews} />,
    question: (
      <ProductQuestionSection data={questions} productName={productName} />
    ),
  };

  return (
    <section>
      <div className="hidden lg:block">
        <div>
          <ul className="flex items-center space-x-[1.25rem]">
            <li>
              <TabButton
                isActive={selectedTab === "description"}
                onClick={() => setSelectedTab("description")}
              >
                <h3>Description</h3>
              </TabButton>
            </li>
            <li>
              <TabButton
                isActive={selectedTab === "specification"}
                onClick={() => setSelectedTab("specification")}
              >
                <h3>Specifications</h3>
              </TabButton>
            </li>
            <li>
              <TabButton
                isActive={selectedTab === "video"}
                onClick={() => setSelectedTab("video")}
              >
                <h3>Videos</h3>
              </TabButton>
            </li>
            <li>
              <TabButton
                isActive={selectedTab === "review"}
                onClick={() => setSelectedTab("review")}
              >
                <h3>Reviews {reviewsCount}</h3>
              </TabButton>
            </li>
            <li>
              <TabButton
                isActive={selectedTab === "question"}
                onClick={() => setSelectedTab("question")}
              >
                <h3>Questions {questionsCount}</h3>
              </TabButton>
            </li>
          </ul>
        </div>

        <article className="pt-[2.375rem]">{tabBody[selectedTab]}</article>
      </div>

      <article className="space-y-[1.75rem] lg:hidden">
        <ItemDetailsAccordion title="Description" isAccordionOpen>
          <InformativeItem type="description" data={long_description} />
        </ItemDetailsAccordion>

        <ItemDetailsAccordion title="Specifications">
          <InformativeItem type="specification" data={specification} />
        </ItemDetailsAccordion>

        <ItemDetailsAccordion title="Videos">
          <ItemVideoSection videoUrl={videos?.[0]?.video_url} />
        </ItemDetailsAccordion>

        <ItemDetailsAccordion title={`Reviews ${reviewsCount}`}>
          <ProductReviewSection data={reviews} />
        </ItemDetailsAccordion>

        <ItemDetailsAccordion title={`Questions ${questionsCount}`}>
          <ProductQuestionSection data={questions} productName={productName} />
        </ItemDetailsAccordion>
      </article>
    </section>
  );
}

export default ProductDetailsTab;
